var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Refine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-28.000000, -119.000000)",
    stroke: "#6B54F9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Refine",
    transform: "translate(29.333310, 120.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.33339,
    y1: 5.66666,
    x2: 8.33339,
    y2: 10.3333,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -8.8817842e-16,
    x2: 1,
    y2: 1.66667,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.66669,
    y1: -8.8817842e-16,
    x2: 4.66669,
    y2: 5.66667,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.33339,
    y1: -8.8817842e-16,
    x2: 8.33339,
    y2: 2.33333,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 5,
    x2: 1,
    y2: 10.3333,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.66669,
    y1: 9,
    x2: 4.66669,
    y2: 10.3333,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,2.66666 C2,2.11437 1.55229,1.66666 1,1.66666 C0.44772,1.66666 -8.8817842e-16,2.11437 -8.8817842e-16,2.66666 L-8.8817842e-16,3.99999 C-8.8817842e-16,4.55227 0.44772,4.99999 1,4.99999 C1.55229,4.99999 2,4.55227 2,3.99999 L2,2.66666 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66669,6.66666 C5.66669,6.11437 5.21897,5.66666 4.66669,5.66666 C4.11441,5.66666 3.66669,6.11437 3.66669,6.66666 L3.66669,8 C3.66669,8.5523 4.11441,9 4.66669,9 C5.21897,9 5.66669,8.5523 5.66669,8 L5.66669,6.66666 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33339,3.33334 C9.33339,2.78106 8.88569,2.33334 8.33339,2.33334 C7.78109,2.33334 7.33339,2.78106 7.33339,3.33334 L7.33339,4.66668 C7.33339,5.21896 7.78109,5.66668 8.33339,5.66668 C8.88569,5.66668 9.33339,5.21896 9.33339,4.66668 L9.33339,3.33334 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefine);
export default __webpack_public_path__ + "static/media/Refine.2f0ead7e.svg";
export { ForwardRef as ReactComponent };